/* eslint-disable no-magic-numbers */
import { HttpErrorResponse, HttpEvent, HttpEventType, HttpResponse } from "@angular/common/http";
import { UploadedFile as UploadedFileBody } from "@dtm-frontend/shared/utils";
import { Observable, interval, map, of, take } from "rxjs";
import { FileUploadErrorType } from "./files-upload.models";

export class FilesUploadApiServiceMock {
    public uploadFile(file: File): Observable<HttpEvent<UploadedFileBody>> {
        return interval(Math.random() * 1000 + 250).pipe(
            take(5),
            map((index): HttpEvent<UploadedFileBody> => {
                if (index < 4) {
                    return {
                        type: HttpEventType.UploadProgress,
                        loaded: (index + 1) * 20,
                        total: 100,
                    };
                }

                return new HttpResponse<UploadedFileBody>({ body: { id: "id-" + file.name, name: file.name } });
            })
        );
    }

    public getFile(fileId: string): Observable<Blob> {
        return of(new Blob(["foo"]));
    }

    public getFilesCompressed(fileIds: string[], fileName: string): Observable<Blob> {
        return of(new Blob(["foo", "bar"]));
    }
    public manageUploadError(error: HttpErrorResponse): { type: FileUploadErrorType } {
        return { type: FileUploadErrorType.Unknown };
    }
}
